export default "__VITE_ASSET__CQyZ_Htg__"